module.exports = __webpack_public_path__ + "img/wu.f4a906bf.png";